import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const sustainabilityImporterSelectors = importerSelectors(
  'sustainability.importer',
);

export default sustainabilityImporterSelectors;
